import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled from 'styled-components';
import { alpha, getColorBlock } from 'utils/ui/colors';
import VisuallyHidden from 'components/VisuallyHidden';

// TO DO: Make aria labels required
// https://github.com/5app/hub/issues/14124
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getMeterColor(_ref) {
  var value = _ref.value,
    _ref$low = _ref.low,
    low = _ref$low === void 0 ? 0 : _ref$low,
    _ref$high = _ref.high,
    high = _ref$high === void 0 ? 1 : _ref$high,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 0 : _ref$min,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 1 : _ref$max,
    theme = _ref.theme;
  if (value <= low || value === min) {
    return getColorBlock('negative', theme);
  } else if (value >= high || value === max) {
    return getColorBlock('positive', theme);
  } else {
    return getColorBlock('neutral', theme);
  }
}
function getMeterWidth(_ref2) {
  var value = _ref2.value,
    _ref2$min = _ref2.min,
    min = _ref2$min === void 0 ? 0 : _ref2$min,
    _ref2$max = _ref2.max,
    max = _ref2$max === void 0 ? 1 : _ref2$max,
    _ref2$visualMin = _ref2.visualMin,
    visualMin = _ref2$visualMin === void 0 ? 0 : _ref2$visualMin;
  var difference = max - min;
  var clampedValue = Math.max(value, visualMin);
  var fraction = (clampedValue - min) / difference;
  return "".concat(fraction * 100, "%");
}
var Wrapper = styled.div.withConfig({
  displayName: "Meter__Wrapper",
  componentId: "sc-1tfhqj9-0"
})(["width:100%;height:0.3rem;background-color:", ";"], function (p) {
  return alpha(p.theme.shade, 0.1);
});
var MockMeter = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(propName) {
    return !['visualMin', 'min', 'max', 'low', 'high', 'value', 'meterColor'].includes(propName);
  }
}).withConfig({
  displayName: "Meter__MockMeter",
  componentId: "sc-1tfhqj9-1"
})(["width:", ";height:100%;background:", ";transition:width 300ms ease-out;"], getMeterWidth, function (p) {
  return p.meterColor ? getColorBlock(p.meterColor, p.theme) : getMeterColor(p);
});
function Meter(props) {
  var color = props.color,
    propsWithoutColor = _objectWithoutProperties(props, _excluded);
  var _props$min = props.min,
    min = _props$min === void 0 ? 0 : _props$min,
    _props$max = props.max,
    max = _props$max === void 0 ? 1 : _props$max,
    _props$visualMin = props.visualMin,
    visualMin = _props$visualMin === void 0 ? 0 : _props$visualMin,
    _props$low = props.low,
    low = _props$low === void 0 ? 0 : _props$low,
    _props$high = props.high,
    high = _props$high === void 0 ? 1 : _props$high,
    value = props.value;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [/*#__PURE__*/_jsx(MockMeter, {
      value: Number(value),
      visualMin: Number(visualMin),
      min: Number(min),
      max: Number(max),
      low: Number(low),
      high: Number(high),
      meterColor: color
    }), /*#__PURE__*/_jsx(VisuallyHidden, _objectSpread({
      as: "meter"
    }, propsWithoutColor))]
  });
}
export default Meter;